import { ConfigService } from '../../';

export class TermsConfig {
	public content	= '';
	public image		= '';

	constructor(private configService: ConfigService) {}

	update(config: any) {
		if (typeof config.terms === 'object') {
			this.content	= typeof config.terms.content === 'string' ? config.terms.content : '';
			this.image		= typeof config.terms.image === 'string' ?
        this.configService.getImage(config.terms.image) : this.image;

			this.configService.terms.next(this);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/termsConfig.ts